import { render, staticRenderFns } from "./scdcdjcf4.vue?vue&type=template&id=5a85ca1c&scoped=true&"
import script from "./scdcdjcf4.vue?vue&type=script&lang=js&"
export * from "./scdcdjcf4.vue?vue&type=script&lang=js&"
import style0 from "./scdcdjcf4.vue?vue&type=style&index=0&id=5a85ca1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85ca1c",
  null
  
)

export default component.exports